import { AirtableService } from '@/services/airtable.service';
export default {
  props: {
    order: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showDialog: false,
      buttonDisabled: false,
      alert: {
        show: false,
        message: ''
      },
      specialShipping: ''
    };
  },
  watch: {
    order: {
      handler() {
        this.specialShipping = this.order['Special Shipping'];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    showAlert(message) {
      this.alert.message = message;
      this.alert.show = true;
    },
    async submitChanges() {
      this.alert.show = false;
      try {
        this.buttonDisabled = true;
        const newOrder = await AirtableService.updateShipping(this.order['Prescription ID'], this.specialShipping);
        this.$emit('update:order', newOrder);
        this.showDialog = false;
      } catch (err) {
        this.showAlert(err);
      } finally {
        this.buttonDisabled = false;
      }
    }
  }
};